import {baseQaConfig} from '../base/qa.config';
import {cbssportsDevConfig} from './dev.config';
import * as extendUtils from '../../../utils/object/extend.utils';
import {PrismConfigOptions} from '../environment-variables.interface';

export const cbssportsQaConfig: PrismConfigOptions = extendUtils.deepExtend({}, [baseQaConfig, cbssportsDevConfig,  {
  environmentName: "Cbs Sports QA Environment",
  ionicEnvName: 'qa',
}]);



// WEBPACK FOOTER //
// ./src/app/environment-variables/cbssports/qa.config.ts